import { Injectable } from '@angular/core';
import TIME_ZONE from '@monsido/ng2/core/constants/timeZone.constant.json';
import {
    ProfileFormData,
    ProfileSource,
    UpdateMePayloadWithRemediation,
} from '@client/app/feature-modules/navigation/profile/edit-profile/types/profile.type';

export interface TimezoneOption {
    name: string;
    value: string;
}

@Injectable({
    providedIn: 'root',
})
export class EditProfileService {
    toProfileState (user: ProfileSource): { profileData: ProfileFormData; organizationName: string } {
        return {
            profileData: {
                email: user.email ?? '',
                first_name: user.first_name ?? '',
                last_name: user.last_name ?? '',
                locale: (user.locale ?? '') as ProfileFormData['locale'],
                timezone: user.timezone ?? '',
                email_notifications: {
                    exports: user.email_notifications?.exports ?? false,
                },
                auth_user_password: '',
                password: '',
                password_confirmation: '',
                accessibility_responsibilities: [...(user.settings?.accessibility_responsibilities ?? [])],
            },
            organizationName: user.customer?.name ?? '',
        };
    }

    buildUpdatePayload (profileData: ProfileFormData): Partial<UpdateMePayloadWithRemediation> {
        const payload: Partial<UpdateMePayloadWithRemediation> = {
            first_name: profileData.first_name,
            last_name: profileData.last_name,
            timezone: profileData.timezone,
            email_notifications: profileData.email_notifications,
            settings: {
                accessibility_responsibilities: profileData.accessibility_responsibilities,
            },
        };

        if (profileData.locale) {
            payload.locale = profileData.locale;
        }

        if (profileData.auth_user_password) {
            payload.auth_user_password = profileData.auth_user_password;
        }

        if (profileData.password) {
            payload.password = profileData.password;
            payload.password_confirmation = profileData.password_confirmation;
        }

        return payload;
    }

    getTimezones (): TimezoneOption[] {
        const zones = TIME_ZONE.zones as Record<string, { long: number }>;

        return Object.keys(zones)
            .sort((a, b) => zones[a].long - zones[b].long)
            .map((key) => ({ name: key, value: key }));
    }
}
